import { render, staticRenderFns } from "./proposalProducts.vue?vue&type=template&id=5b433f2e&scoped=true&"
import script from "./proposalProducts.vue?vue&type=script&lang=js&"
export * from "./proposalProducts.vue?vue&type=script&lang=js&"
import style0 from "./proposalProducts.vue?vue&type=style&index=0&id=5b433f2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b433f2e",
  null
  
)

export default component.exports